import { Component, Directive, ElementRef, HostListener, Input, OnInit, Renderer2, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';


import { FormBuilder, FormGroup } from '@angular/forms';
import {
  ApexChart,
  ApexAxisChartSeries,
  ChartComponent,
  ApexDataLabels,
  ApexPlotOptions,
  ApexYAxis,
  ApexLegend,
  ApexGrid,
  ApexNonAxisChartSeries,
  ApexXAxis
} from "ng-apexcharts";
import { SortConfig } from '../../core/interface/SortConfig';
import { PaginationConfig } from '../../core/interface/PaginationConfig';
import { ActivatedRoute, Router } from '@angular/router';
import { OfficeLeaseService } from '../../core/services/office-lease.service';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { OfficeLease, OfficeLeaseOccupancy, OfficeLeaseRevenue, OfficeLeaseTenant, 
  OfficeLeaseBuildingGraph, OfficeLeaseActivities, OfficeLeaseActivitiesHeader, Meta } from '../../core/models/office-lease';
    
import { TenantModalService } from '../../core/tenant-modal/tenant-modal.service';
import { BuildingModalService } from '../../core/building-modal/building-modal.service'; //TW20251010


export type ChartOptions = {
  series: ApexAxisChartSeries;  // Hapus union type dengan undefined
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  grid: ApexGrid;
  colors: string[];
  legend: ApexLegend;
};

@Component({
  selector: 'app-office-lease',
  templateUrl: './office-lease.component.html',
  styleUrl: './office-lease.component.css'
})

export class OfficeLeaseComponent implements OnInit {
  @ViewChild('sliderWrapper') sliderWrapper!: ElementRef;
  
  private isDragging = false;
  private startX = 0;
  private scrollLeftStart = 0;

  enableDragToScroll() {
    const slider = this.sliderWrapper.nativeElement;
    
    // Mouse/Touch events untuk drag scroll
    slider.addEventListener('mousedown', (e: MouseEvent) => {
      this.isDragging = true;
      this.startX = e.pageX - slider.offsetLeft;
      this.scrollLeftStart = slider.scrollLeft;
      slider.style.cursor = 'grabbing';
      slider.style.userSelect = 'none';
    });

    slider.addEventListener('mouseleave', () => {
      this.isDragging = false;
      slider.style.cursor = 'grab';
      slider.style.userSelect = '';
    });

    slider.addEventListener('mouseup', () => {
      this.isDragging = false;
      slider.style.cursor = 'grab';
      slider.style.userSelect = '';
    });

    slider.addEventListener('mousemove', (e: MouseEvent) => {
      if (!this.isDragging) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - this.startX) * 1.5;
      slider.scrollLeft = this.scrollLeftStart - walk;
    });

    // Untuk touch device
    slider.addEventListener('touchstart', (e: TouchEvent) => {
      this.isDragging = true;
      this.startX = e.touches[0].pageX - slider.offsetLeft;
      this.scrollLeftStart = slider.scrollLeft;
    });

    slider.addEventListener('touchmove', (e: TouchEvent) => {
      if (!this.isDragging) return;
      e.preventDefault();
      const x = e.touches[0].pageX - slider.offsetLeft;
      const walk = (x - this.startX) * 1.5;
      slider.scrollLeft = this.scrollLeftStart - walk;
    });

    slider.addEventListener('touchend', () => {
      this.isDragging = false;
    });
    
    // Set initial cursor
    slider.style.cursor = 'grab';
  }

  

  


  @ViewChild("chart") chart!: ChartComponent;
  public chartOptions!: ChartOptions;
  @Input('tenantInfo') tenantData: string[] = [];


  leaseItem: OfficeLease[] = [];
  displayedData: OfficeLease[] = [];
  ItemsTenant: OfficeLeaseTenant = {} as OfficeLeaseTenant;
  ItemsBuildingGraph: OfficeLeaseBuildingGraph[] = []; //TW20251010
  ItemsRevenue: OfficeLeaseRevenue[] = [];
  ItemsOccupancy: OfficeLeaseOccupancy = {} as OfficeLeaseOccupancy;
  ItemSalesActivites: OfficeLeaseActivities = {} as OfficeLeaseActivities;
  ItemHeaders: OfficeLeaseActivitiesHeader[] = []

  isLoading = false;
  error = '';
  MaxLength: number = 0;

  // Filters
  searchForm !: FormGroup;
  sortBy = '';
  startDate: string = '';
  endDate: string = '';
  metaStartDate: string = '';
  metaEndDate: string = '';


  sortConfig: SortConfig = {
    column: '',
    direction: ''
  };

  paginationConfig: PaginationConfig = {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0
  };

  searchTerm: string = '';

  private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();
  isLoadingOccupancy = false;

  selectedFilter: string = '';
  metaData: Meta = {} as Meta;
  showAllData: boolean = false;
  displayLimit: number = 10;


  // Loading states
  isLoadingOfficeLease = false;

  
  expandedStates: boolean[] = [];

  constructor(
    private officeLeaseService: OfficeLeaseService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private el: ElementRef,
    private renderer: Renderer2,
    private modalService: TenantModalService,
    private buildingmodalService: BuildingModalService  //TW20251010
    
  ) {
    this.setupSearchSubscription();

    this.searchForm = this.fb.group({
      searchTerm: ['']
    });
  }

  ngAfterViewInit() {
    
    this.enableDragToScroll();
  }
 

  private setupSearchSubscription(): void {
    this.searchSubject.pipe(
      takeUntil(this.destroy$),
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(term => {
      // Update URL dan load data hanya jika ada term
      if (term.trim()) {
        this.updateUrlParams();
      }
      this.loadOfficeLease(term);
    });
  }


  ngOnInit(): void {
    // Load dates from localStorage
    this.loadDatesFromLocalStorage();

    this.loadAllData();
    this.subscribeToRouteParams();
  }

  private loadDatesFromLocalStorage(): void {
    const startDate = localStorage.getItem('startDate');
    const endDate = localStorage.getItem('endDate');

    this.startDate = startDate || '';
    this.endDate = endDate || '';
  }

  private loadAllData(): void {
    this.loadTenant();
    this.loadRevenue();
    this.loadOccupancy();
    this.loadOfficeLeaseActivities();
    //this.loadBuildingGraph(); //TW20251010
  }

  private subscribeToRouteParams(): void {
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        this.searchTerm = params['search'] || '';
        this.sortConfig.column = params['sortColumn'] || '';
        this.sortConfig.direction = params['sortDirection'] as 'ASC' | 'DESC' | '' || '';
        this.paginationConfig.currentPage = Number(params['page']) || 1;

        this.loadOfficeLease(this.searchTerm);
      });
  }

  public refreshDashboardData(): void {

    // Update localStorage jika diperlukan
    if (this.startDate) localStorage.setItem('startDate', this.startDate);
    if (this.endDate) localStorage.setItem('endDate', this.endDate);

    // Reload data
    this.loadOccupancy();
  }

  loadOfficeLease(searchTerm?: string): void {
    this.isLoading = true;

    this.officeLeaseService.getOfficeLease(
      this.paginationConfig.currentPage,
      this.paginationConfig.itemsPerPage,
      searchTerm?.trim() || '',
      this.sortConfig.column,
      this.sortConfig.direction.toUpperCase() as 'ASC' | 'DESC',
      this.startDate,
      this.endDate
    ).subscribe({
      next: (response) => {
        this.displayedData = response.data;

        // console.log(this.displayedData);
        this.paginationConfig.totalItems = response.pagination.total_items;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading office lease data:', error);
        this.isLoading = false;
        this.displayedData = [];
      }
    });
  }

  loadOfficeLeaseActivities(): void {
    this.isLoading = true;

    this.officeLeaseService.getOfficeLeaseSalesActivities(
      this.startDate,
      this.endDate,
      this.selectedFilter
    ).subscribe({
      next: (response) => {
        this.ItemSalesActivites = response.data;
        this.metaData = response.meta;

        // Reset show all data ketika load data baru
        this.showAllData = false;

        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading Sales Activities data:', error);
        this.isLoading = false;
        this.ItemSalesActivites = {} as OfficeLeaseActivities;
      }
    });
  }

  // Method untuk handle click category button
  onCategoryClick(categoryValue: any): void {
    // Jika category yang sama diklik lagi, reset filter (show all)
    if (this.selectedFilter === categoryValue) {
      this.selectedFilter = '';
    } else {
      this.selectedFilter = categoryValue;
    }

    // Reset pagination
    this.showAllData = false;

    // Load data dengan filter baru
    this.loadOfficeLeaseActivities();
  }

  // Method untuk cek apakah category button active
  isCategoryActive(categoryValue: string): boolean {
    return this.selectedFilter === categoryValue;
  }

  // Method untuk mendapatkan data yang akan ditampilkan
  getDisplayedData(): any[] {
    if (!this.ItemSalesActivites.chart) {
      return [];
    }

    if (this.showAllData) {
      return this.ItemSalesActivites.chart;
    }

    return this.ItemSalesActivites.chart.slice(0, this.displayLimit);
  }

  // Method untuk clear filter
  clearFilter(): void {
    this.selectedFilter = '';
    this.showAllData = false;
    this.loadOfficeLeaseActivities();
  }

  // Method untuk mendapatkan text filter status
  getFilterStatusText(): string {
    if (this.selectedFilter) {
      return `Filtered by: ${this.selectedFilter}`;
    }
    return 'All Activities';
  }

  showTenantDetails(tenantData: string | string[], event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();

    let formattedTenants: string[] = [];

    // Handle different types of tenant data
    if (Array.isArray(tenantData)) {
      // If tenantData is already an array, format each item
      formattedTenants = tenantData
        .filter(tenant => tenant && tenant.trim().length > 0)
        .map(tenant => tenant.trim() + ',');
    } else if (tenantData && typeof tenantData === 'string') {
      // If tenantData is a string, split and format
      if (tenantData.includes(',')) {
        formattedTenants = tenantData
          .split(',')
          .map(tenant => tenant.trim())
          .filter(tenant => tenant.length > 0)
          .map(tenant => tenant + ',');
      } else if (tenantData.includes(';')) {
        formattedTenants = tenantData
          .split(';')
          .map(tenant => tenant.trim())
          .filter(tenant => tenant.length > 0)
          .map(tenant => tenant + ',');
      } else {
        // Single tenant
        formattedTenants = [tenantData.trim() + ','];
      }
    }

    // Open the modal with the formatted tenant array - no need for position anymore
    this.modalService.openModal(formattedTenants);
  }
  //TW20251010
  showBuildingGraph(buildingId: number, buildingName: string, event: MouseEvent): void {
  event.preventDefault();
  event.stopPropagation();

  console.log('Loading building graph data for ID:', buildingId);

  // Perbaikan: buildingmodalService (huruf 'm' kecil)
  this.officeLeaseService.getOfficeLeaseBuildingGraph(buildingId, this.startDate,
      this.endDate).subscribe({
    next: (response: any) => {  // Tambahkan type annotation
      console.log('API Response:', response);
      
      if (response.success) {
        // Format data dari API sesuai dengan interface BuildingData
        const buildingData = response.data.map((item: any) => ({
          floor_name: item.floor_name || item.floor,
          floor_area: item.floor_area || item.floor_area,
          tenant_name: item.tenant_name || item.tenant,
          tenant_type: item.tenant_type || item.type,
          pctg_usage: item.pctg_usage || item.usage_percentage || item.percentage, // Perbaikan: item.percentage bukan item_percentage
          used_area: item.used_area || item.used_area,
          uom: item.uom || item.uom || 'sqm' // Perbaikan: menambahkan uom dengan default 'sqm'
        }));
        
        console.log('Formatted building data:', buildingData);

        // Perbaikan: buildingmodalService 
        this.buildingmodalService.openModal(buildingData, buildingName);
        
      } else {
        console.error('API returned error:', response.message);
        this.showErrorAlert('Failed to load building data: ' + response.message);
      }
    },
    error: (error: any) => {  // Tambahkan type annotation
      console.error('API Error:', error);
      console.error('Error details:', error.error);
      this.showErrorAlert('Network error. Please try again later.');
    }
  });
}

private showErrorAlert(message: string): void {
  alert(message);
}



  loadOccupancy(): void {
    this.isLoadingOccupancy = true;

    this.officeLeaseService.getOfficeLeaseOccupancy(
      this.startDate,
      this.endDate
    ).subscribe({
      next: (response) => {
        this.ItemsOccupancy = response.data;
        this.metaStartDate = response.meta.start_date;
        this.metaEndDate = response.meta.end_date;
        this.MaxLength = response.data.max_pct_value;
        this.initChartData(response.data.chart, this.MaxLength);
        this.isLoadingOccupancy = false;
      },
      error: (error) => {
        console.error('Error loading office lease  Occupancy data:', error);
        this.isLoadingOccupancy = false;
        this.ItemsOccupancy = {} as OfficeLeaseOccupancy;
      }
    });
  }

  loadTenant(): void {
    this.isLoading = true;

    this.officeLeaseService.getOfficeLeaseTenant(
      this.startDate,
      this.endDate
    ).subscribe({
      next: (response) => {
        this.ItemsTenant = response.data;
        // console.log(this.ItemsTenant);
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading office lease Tenant data:', error);
        this.isLoading = false;
        this.ItemsTenant = {} as OfficeLeaseTenant;
      }
    });
  }

  //TW20251010
  loadBuildingGraph(searchTerm?: number): void {
    this.isLoading = true;
    this.error = ''; // Reset error sebelumnya
    const paramsId = this.route.snapshot.paramMap.get('id');
    console.log(paramsId);

    this.officeLeaseService.getOfficeLeaseBuildingGraph(
      paramsId || '',
      this.startDate,
      this.endDate
    ).subscribe({
      next: (response) => {
        if (response && response.data) {
          // Memeriksa struktur respons sebelum mengassign
          this.ItemsBuildingGraph = response.data;
          this.isLoading = false;
        } else {
          this.error = 'Respons API tidak valid';
          this.isLoading = false;
          this.ItemsBuildingGraph = [];
        }
      },
      error: (error) => {
        let errorMessage = 'Error saat memuat building floor: ';

        if (error.status === 200 && error.statusText === 'OK') {
          errorMessage += 'Error saat memproses format respons JSON';
        } else if (error.error instanceof ErrorEvent) {
          // Error dari sisi client
          errorMessage += `Error client: ${error.error.message}`;
        } else {
          // Error dari sisi server
          errorMessage += `Kode: ${error.status}, Pesan: ${error.message}`;
        }

        console.error(errorMessage, error);
        this.error = errorMessage;
        this.isLoading = false;
        this.ItemsBuildingGraph = [];
      }
    });
  }

  loadRevenue(): void {
    this.isLoading = true;

    this.officeLeaseService.getOfficeLeaseRevenue(
      this.startDate,
      this.endDate
    ).subscribe({
      next: (response) => {
        this.ItemsRevenue = response.data;
        // console.log(this.ItemsRevenue);
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading office lease revenue data:', error);
        this.isLoading = false;
        this.ItemsRevenue = [];
      }
    });
  }


  get totalPages(): number {
    return Math.ceil(this.paginationConfig.totalItems / this.paginationConfig.itemsPerPage);
  }

  get pageNumbers(): number[] {
    const currentPage = this.paginationConfig.currentPage;
    const totalPages = this.totalPages;

    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    if (endPage - startPage < 4) {
      startPage = Math.max(1, endPage - 4);
    }

    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  }

  onSearch(event: KeyboardEvent): void {
    const target = event.target as HTMLInputElement;
    const term = target.value;

    // Update searchTerm dan trigger pencarian
    this.searchTerm = term;
    this.paginationConfig.currentPage = 1;
    this.searchSubject.next(term);

    // Jika input kosong, langsung clear search dan reset data
    if (!term.trim()) {
      const queryParams: Record<string, string | number | null> = {
        page: 1,
        search: null
      };

      // Jika ada sort config, pertahankan
      if (this.sortConfig.column && this.sortConfig.direction) {
        queryParams['sortColumn'] = this.sortConfig.column;
        queryParams['sortDirection'] = this.sortConfig.direction;
      }

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams,
        replaceUrl: true
      });

      this.loadOfficeLease('');
    }
  }

  onSort(column: string): void {
    if (this.sortConfig.column === column) {
      this.sortConfig.direction = this.sortConfig.direction === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.sortConfig.column = column;
      this.sortConfig.direction = 'ASC';
    }

    this.paginationConfig.currentPage = 1; // Reset to first page on sort
    this.updateUrlParams();
    this.loadOfficeLease(this.searchTerm);
  }

  getSortIcon(column: string): string {
    // Jika bukan kolom yang sedang di-sort, tampilkan icon default
    if (this.sortConfig.column !== column) {
      return 'ri-expand-up-down-line'; // Remix icon untuk unsorted
    }

    // Jika kolom yang sedang di-sort
    if (this.sortConfig.direction === 'ASC') {
      return 'ri-arrow-up-line'; // Remix icon arrow up
    } else if (this.sortConfig.direction === 'DESC') {
      return 'ri-arrow-down-line'; // Remix icon arrow down
    }

    return 'ri-expand-up-down-line'; // Default fallback
  }

  onPageChange(page: number): void {
    if (page < 1 || page > this.totalPages || page === this.paginationConfig.currentPage) {
      return;
    }

    this.paginationConfig.currentPage = page;
    this.updateUrlParams();
    this.loadOfficeLease(this.searchTerm);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onFirstPage(): void {
    this.onPageChange(1);
  }

  onLastPage(): void {
    this.onPageChange(this.totalPages);
  }

  onPrevPage(): void {
    this.onPageChange(this.paginationConfig.currentPage - 1);
  }

  onNextPage(): void {
    this.onPageChange(this.paginationConfig.currentPage + 1);
  }

  get displayRange(): { start: number; end: number; total: number } {
    const start = (this.paginationConfig.currentPage - 1) * this.paginationConfig.itemsPerPage + 1;
    const end = Math.min(
      start + this.paginationConfig.itemsPerPage - 1,
      this.paginationConfig.totalItems
    );

    return {
      start: this.paginationConfig.totalItems === 0 ? 0 : start,
      end,
      total: this.paginationConfig.totalItems
    };
  }

  private updateUrlParams(): void {
    const queryParams: any = {
      page: this.paginationConfig.currentPage
    };

    // Hanya tambahkan search param jika ada nilai
    if (this.searchTerm?.trim()) {
      queryParams.search = this.searchTerm.trim();
    } else {
      queryParams.search = null; // Hapus search param
    }

    if (this.sortConfig.column && this.sortConfig.direction) {
      queryParams.sortColumn = this.sortConfig.column;
      queryParams.sortDirection = this.sortConfig.direction;
    }

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams,
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.paginationConfig.currentPage = 1;
    this.updateUrlParams();
    this.loadOfficeLease('');
  }

  private initChartData(chartData: any[], MaxLength: number): void {

    // Ekstrak value untuk series data
    const seriesData = chartData.map(item => item.value);
    const formattedDates = chartData.map(item => item.date);

    // Logika untuk warna - default semua #B6D1C1, yang terakhir #191919
    const xaxisLabelColors = Array(chartData.length).fill("#B6D1C1");
    if (chartData.length > 0) {
      xaxisLabelColors[chartData.length - 1] = "#191919";
    }

    /*  TW20251007
    this.chartOptions = {
      series: [{
        name: "Persentase",
        data: seriesData,
      }],
      chart: {
        height: 400,
        width: '100%',
        type: "bar",
        events: {
          // click: function (chart, w, e) {
          //   // console.log(chart, w, e)
          // },
          click: function (event, chartContext, config) {
            const defaultColors = Array(7).fill("#B6D1C1");

            if (config.dataPointIndex !== -1) {
              defaultColors[config.dataPointIndex] = "#126936";
            }

            chartContext.updateOptions({
              colors: defaultColors
            }, false, false);
          },

          mouseMove: function (event, chartContext, config) {
            const defaultColors = Array(7).fill("#B6D1C1"); // Membuat array dengan 7 warna default

            if (config.dataPointIndex !== -1) {
              defaultColors[config.dataPointIndex] = "#126936";
            }

            chartContext.updateOptions({
              colors: defaultColors
            }, false, false);
          },
          // mouseLeave: function(event, chartContext, config) {
          //   chartContext.updateOptions({
          //     colors: Array(7).fill("#126936")
          //   }, false, false);
          // },
        },
        zoom: {
          enabled: false
        },
        toolbar: {
          show: false
        },
      },
      colors: Array(chartData.length).fill("#B6D1C1"),
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "60%",
          distributed: true,
          dataLabels: {
            position: 'top'  // Properti position dipindahkan ke sini
          },
          borderRadius: 0
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val + "%"  // Menambahkan simbol % pada label
        },
        offsetY: -25,    // Mengatur jarak label dari bar
        style: {
          fontSize: '12px',
          colors: ["#126936"], // Warna teks label
          fontWeight: 'bold'
        },
        distributed: true,
        // orientation: 'vertical'

      },
      legend: {
        show: false
      },
      grid: {
        show: true,
        position: 'back',
        borderColor: '#E6E6E6',
        xaxis: {
          lines: {
            show: false  // Nonaktifkan garis vertikal
          },
        },
        yaxis: {
          lines: {
            show: false,  // Aktifkan garis horizontal
          }
        },
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 20
        }
      },
      xaxis: {
        categories: formattedDates,
        labels: {
          rotate: -45,  // Tidak memutar label
          trim: false, // Tidak memotong label
          hideOverlappingLabels: false,
          rotateAlways: true,
          // offsetY: 5,
          style: {
            colors: [
              "#B6D1C1",
              "#B6D1C1",
              "#B6D1C1",
              "#B6D1C1",
              "#B6D1C1",
              "#B6D1C1",
              "#191919"
            ],
            cssClass: 'apexcharts-xaxis-label',
            fontSize: "12px",
            fontWeight: 'bold'
          },
          offsetY: 8,
          offsetX: 10
        },
        tickPlacement: 'on',
      },
      yaxis: {
        title: {
          text: ""
        },
        min: 0,
        max: MaxLength,
        tickAmount: 5,
        labels: {
          formatter: function (val) {
            return val + "%"
          },
          style: {
            colors: '#666666',
            fontSize: '12px',
            fontWeight: 'normal'
          },
          offsetX: 10
        },
        axisBorder: {
          show: true,
          color: "#E6E6E6"
        },
        axisTicks: {
          show: true,
          color: "#E6E6E6",
          width: 6,
          offsetX: 0
        },
        crosshairs: {
          show: false
        }
      },

    };
    */
   this.chartOptions = {
      series: [{
        name: "Persentase",
        data: seriesData,
      }],
      chart: {
        height: 400,
        width: '100%',
        type: "bar",
        events: {
          click: function (event, chartContext, config) {
            const defaultColors = Array(7).fill("#B6D1C1");

            if (config.dataPointIndex !== -1) {
              defaultColors[config.dataPointIndex] = "#126936";
            }

            chartContext.updateOptions({
              colors: defaultColors
            }, false, false);
          },

          mouseMove: function (event, chartContext, config) {
            const defaultColors = Array(7).fill("#B6D1C1");

            if (config.dataPointIndex !== -1) {
              defaultColors[config.dataPointIndex] = "#126936";
            }

            chartContext.updateOptions({
              colors: defaultColors
            }, false, false);
          },
        },
        zoom: {
          enabled: false
        },
        toolbar: {
          show: false
        },
      },
      colors: Array(chartData.length).fill("#B6D1C1"),
      plotOptions: {
        bar: {
          horizontal: true, // DIUBAH: false → true
          barHeight: "60%", // DIUBAH: columnWidth → barHeight
          distributed: true,
          dataLabels: {
            position: 'end' // DIUBAH: 'top' → 'end'
          },
          borderRadius: 0
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val + "%"
        },
        offsetX: 10, // DIUBAH: offsetY → offsetX
        style: {
          fontSize: '12px',
          colors: ["#126936"],
          fontWeight: 'bold'
        },
        distributed: true,
      },
      legend: {
        show: false
      },
      grid: {
        show: true,
        position: 'back',
        borderColor: '#E6E6E6',
        xaxis: {
          lines: {
            show: true, // DIUBAH: false → true
          },
        },
        yaxis: {
          lines: {
            show: false,
          }
        },
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 20
        }
      },
      xaxis: {
        categories: formattedDates, // DIUBAH: pindahkan categories dari xaxis ke yaxis
        labels: {
          formatter: function (val) {
            return val + "%";
          },
          style: {
            colors: '#666666',
            fontSize: '12px',
            fontWeight: 'normal'
          }
        },
        min: 0,
        max: MaxLength,
        tickAmount: 5,
        axisBorder: {
          show: true,
          color: "#E6E6E6"
        },
        axisTicks: {
          show: true,
          color: "#E6E6E6"
        },
        title: {
          text: ""
        },
        crosshairs: {
          show: false
        }
      },
      yaxis: {
        
        labels: {
          style: {
            /*colors: [
              "#B6D1C1",
              "#B6D1C1",
              "#B6D1C1",
              "#B6D1C1",
              "#B6D1C1",
              "#B6D1C1",
              "#191919"
            ],*/
            colors: Array(formattedDates.length).fill("#B6D1C1"),
            cssClass: 'apexcharts-yaxis-label', // DIUBAH: xaxis-label → yaxis-label
            fontSize: "12px",
            fontWeight: 'bold'
          },
          offsetX: -10, // DIUBAH: offset disesuaikan
        },
        // HAPUS property yang tidak diperlukan untuk yaxis horizontal:
        // title, min, max, tickAmount, formatter, axisBorder, axisTicks, crosshairs, opposite
      },
    };
    
  }

  getPercentageClass(percentage: number): string {
    if (percentage >= 100) {
      return 'badge custom-progress-success';
    }
    return 'badge custom-progress-danger';
  }
  toggleExpand(index: number) {
    this.expandedStates[index] = !this.expandedStates[index];
  }

}
